// extracted by mini-css-extract-plugin
export default {"tabs":"k_bf","tab-list":"k_bg","tab":"k_bh","active":"k_bj"};